<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'Partnerzy'" [name]="'Wyszukiwarka'"></app-breadcrumb>
<div class="partners-search-engine-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="partners-list-filters">

<!--    <mat-form-field class="partners-list-filter">-->
<!--      <mat-label>Pełna nazwa</mat-label>-->
<!--      <input matInput placeholder="Pełna nazwa" name="contains$fullName" [(ngModel)]="initialFilters.contains$fullName">-->
<!--    </mat-form-field>-->

<!--    <mat-form-field class="partners-list-filter">-->
<!--      <mat-label>Nazwa skrócona</mat-label>-->
<!--      <input matInput placeholder="Nazwa skrócona" name="contains$shortName" [(ngModel)]="initialFilters.contains$shortName">-->
<!--    </mat-form-field>-->

    <mat-form-field class="partners-list-filter">
      <mat-label>NIP</mat-label>
      <input matInput placeholder="NIP" name="nipFull" [(ngModel)]="initialFilters.nipFull">
    </mat-form-field>

<!--    <mat-form-field class="facilities-list-filter">-->
<!--      <mat-label>Kod pocztowy</mat-label>-->
<!--      <input matInput placeholder="08-110"  name="zipCode" [(ngModel)]="initialFilters.zipCode">-->
<!--    </mat-form-field>-->

<!--    <mat-form-field class="partners-list-filter partners-list-filter-address">-->
<!--      <mat-label>Adres</mat-label>-->
<!--      <input matInput placeholder="Armii Krajowej 18, Siedlce 08-110" name="address" [(ngModel)]="initialFilters.address">-->
<!--    </mat-form-field>-->

<!--    <app-dict-->
<!--      [multiple]="false" [dictType]="'address_state'"-->
<!--      [label]="'Województwo'" class="partners-list-filter"-->
<!--      [(ngModel)]="initialFilters.state" name="state"-->
<!--    ></app-dict>-->

  </form>

  <div class="partners-list-buttons">
     <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table  [dataSource]="dataSource">

    <!-- Position Column -->
    <ng-container matColumnDef="fullname">
      <th mat-header-cell *matHeaderCellDef> Pełna Nazwa </th>
      <td mat-cell *matCellDef="let element">
        {{element.fullName ? element.fullName : "\<\brak nazwy\>"}}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa Skrócona </th>
      <td mat-cell *matCellDef="let element">
     {{element.shortName ? element.shortName : "\<\brak nazwy\>"}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="nip">
      <th mat-header-cell *matHeaderCellDef> NIP </th>
      <td mat-cell *matCellDef="let element"> {{element.nip}} </td>
    </ng-container>

    <ng-container matColumnDef="headquartersAddress">
      <th mat-header-cell *matHeaderCellDef> Adres siedziby </th>
      <td mat-cell *matCellDef="let element">
        <app-table-address [address]="element.headquartersAddress"></app-table-address>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) Partnera</th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="element.assetsRegional">
            {{element.assetsRegional.firstName}} {{element.assetsRegional.lastName}}
        </span>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr  mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>

